import jsPDF from 'jspdf';
import 'jspdf-autotable';

export const exportToPDF = (title, columns, rows, filename, subtitle = '') => {
  const doc = new jsPDF('l', 'mm', 'a4'); // landscape
  
  // Header
  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.text(title, 14, 18);
  
  if (subtitle) {
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(100);
    doc.text(subtitle, 14, 25);
    doc.setTextColor(0);
  }

  // Table
  doc.autoTable({
    head: [columns],
    body: rows,
    startY: subtitle ? 30 : 24,
    styles: { fontSize: 8, cellPadding: 2 },
    headStyles: { fillColor: [41, 65, 148], textColor: 255, fontStyle: 'bold' },
    alternateRowStyles: { fillColor: [245, 247, 250] },
    margin: { top: 10 }
  });

  // Footer
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setTextColor(150);
    doc.text(`Page ${i} of ${pageCount}`, doc.internal.pageSize.width - 30, doc.internal.pageSize.height - 8);
    doc.text(`Generated: ${new Date().toLocaleString()}`, 14, doc.internal.pageSize.height - 8);
  }

  doc.save(`${filename}.pdf`);
};
